/**
 * Pure helpers for wishlist heart sleeve-fill motion.
 * Animation runs only when adding (outline → filled), not on remove.
 */

import { MOTION } from "../styles/motionTokens";

export const SLEEVE_FILL_CLASS = "heart-sleeve-fill";

export function shouldPlaySleeveFill({ wasWishlisted, willBeWishlisted }) {
  return !wasWishlisted && !!willBeWishlisted;
}

export function sleeveFillDurationMs() {
  return MOTION.sleevePressMs + MOTION.foilFlashMs * 0.35;
}
